/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.quick-nav__wrapper[_ngcontent-%COMP%]{min-height:58px;z-index:10}@media screen and (min-width:1024px){.quick-nav__nav[_ngcontent-%COMP%]{width:1200px}}"];
export { styles as styles };
